export const META_PIXEL_ID = '2343529679785881'

let routeTrackingBound = false
let lastTrackedHref = null

/**
 * Стандартный сниппет + защита от SPA-дублей:
 * fbevents.js по умолчанию вешает PageView на pushState и replaceState.
 * Next.js на одну смену маршрута дергает оба — отсюда 2 события и stale dl.
 */
export function getMetaPixelSnippet() {
  return `
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq.disablePushState = true;
    fbq('set', 'autoConfig', false, '${META_PIXEL_ID}');
    if (!window.__metaPixelInited) {
      window.__metaPixelInited = true;
      fbq('init', '${META_PIXEL_ID}');
      fbq('track', 'PageView');
    }
  `
}

export function getMetaPixelNoscriptSrc() {
  return `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
}

export function ensureMetaPixel() {
  if (typeof window === 'undefined') return

  if (!window.fbq) {
    const script = document.createElement('script')
    script.innerHTML = getMetaPixelSnippet()
    document.head.append(script)
    return
  }

  window.fbq.disablePushState = true
  window.fbq('set', 'autoConfig', false, META_PIXEL_ID)

  if (!window.__metaPixelInited) {
    window.__metaPixelInited = true
    window.fbq('init', META_PIXEL_ID)
    window.fbq('track', 'PageView')
  }
}

function locationMatchesRoute(url) {
  if (typeof window === 'undefined' || !url) return true

  const { href, pathname, search, hash } = window.location
  return (
    href === url ||
    pathname + search + hash === url ||
    pathname + search === url
  )
}

function trackMetaPageView() {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return

  const href = window.location.href
  if (href === lastTrackedHref) return

  lastTrackedHref = href
  window.fbq('track', 'PageView')
}

function onRouteChangeComplete(url) {
  const fire = () => trackMetaPageView()

  if (locationMatchesRoute(url)) {
    fire()
    return
  }

  window.setTimeout(fire, 0)
}

export function bindMetaPixelRouteTracking(router) {
  if (routeTrackingBound || !router?.events) return

  routeTrackingBound = true
  if (typeof window !== 'undefined') {
    lastTrackedHref = window.location.href
  }
  router.events.on('routeChangeComplete', onRouteChangeComplete)
}
